import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { SitemapCategoryCms } from '~/cms/interfaces/sitemap.cms.interface';
import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
import { TitleService } from '~/core/services/title/title.service';

@Component({
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
})
export class SeoSitemapComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  public categories: TabBarLinkInterface[];
  public sitemapCategory: SitemapCategoryCms;
  public title: string;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: TitleService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.titleService.setPageTitle('seo.sitemap.title');

    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ data }) => {
        this.title = data?.title;
        this.categories = data?.categories;
        this.sitemapCategory = data?.sitemapCategory;
      })
    );
  }
}
